import { render, staticRenderFns } from "./Catchs.vue?vue&type=template&id=ade00bf6&scoped=true"
import script from "./Catchs.vue?vue&type=script&lang=js"
export * from "./Catchs.vue?vue&type=script&lang=js"
import style0 from "./Catchs.vue?vue&type=style&index=0&id=ade00bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade00bf6",
  null
  
)

export default component.exports